const FEED_ITEM_REJECTION_DESCRIPTION = {
  PROPOSAL_REJECTED: 'A proposta foi desconsiderada após análise.',
  PROPOSAL_REVIVAL: 'A proposta foi reativada.',
  PROPOSAL_VALUE_BELOW_MINIMUM:
    'Empréstimo abaixo do valor mínimo de R$ 30.000.',
  PROPOSAL_EXPIRED:
    'Proposta expirada. Tente cadastrar o lead novamente ou entre em contato com seu contato na Creditas.',
  OUT_OF_POLICY_COLLATERAL: 'A garantia está fora da política.',
  OUT_OF_POLICY_CREDIT:
    'Proposta fora da política interna: cliente possui débitos em aberto acima do aceito.',
  OUT_OF_POLICY_VEHICLE_YEAR:
    'Garantia fora da política interna: aceitamos carros com até 15 anos do ano de fabricação.',
  OUT_OF_POLICY_SCORE_BELOW_MINIMUM:
    'Proposta fora da política interna: score abaixo do valor mínimo.',
  OUT_OF_POLICY_CONTACT_TO_INFORMATION:
    'Proposta fora da política interna: procure seu contato na Creditas para rever a proposta.',
  OUT_OF_POLICY_NOT_DETERMINED:
    'Proposta fora da política interna: motivo não pode ser aberto.',
  OUT_OF_POLICY_COLLATERAL_TYPE:
    'Garantia fora da política interna: tipo de garantia não aceito.',
  OUT_OF_POLICY_COLLATERAL_DOCUMENTATION:
    'Garantia fora da política interna: problemas com a documentação do imóvel.',
  OUT_OF_POLICY_COLLATERAL_VALUE:
    'Valor solicitado não foi aprovado. Entre em contato com a pessoa consultora para rever a proposta.',
  OUT_OF_POLICY_COLLATERAL_UNMET_REGION:
    'Garantia fora da política interna: imóvel localizado fora da área de cobertura.',
  OUT_OF_POLICY_LOW_INCOME_VALUE:
    'Proposta fora da politica interna: renda abaixo do valor aceito.',
  OUT_OF_POLICY_INCOME_VALUE_PROOF:
    'Proposta fora da politica interna: não foi possível comprovar renda',

  DROP_OUT_NOT_INFORMED: 'Motivo da desistência não informado.',
  DROP_OUT_COLLATERAL_SALE: 'Cliente está vendendo o imóvel.',
  DROP_OUT_INTERNAL:
    'Proposta recusada por erro interno. Tente cadastrar o lead novamente ou fale com seu contato na Creditas.',
  CONTACT_TOO_MANY_CALLS:
    'Cliente desistiu por excesso de tentativas de contato.',
  CONTACT_WITHOUT_SUCCESS: 'Várias tentativas de contato sem sucesso.',
  BORROWER_WITHOUT_COLLATERAL:
    'Cliente não tem imóvel para garantia do empréstimo.',
  DUPLICITY: 'Cliente com proposta em andamento na Creditas.',
  ANOTHER_LOAN_CHOICE: 'Cliente optou por outro tipo de empréstimo.',
  NOT_INFORMED: false,
  DROP_OUT_UNINTEREST_VEHICLE_SOLD: 'Carro do cliente foi vendido.',
  DROP_OUT_UNINTEREST_WANTS_AN_EASIER_PROCESS:
    'Cliente desejava um processo de empréstimo mais simples.',
  DROP_OUT_AUTO_TRANSFER_NAME:
    'Cliente desistiu da proposta: não quer, ou não consegue transferir o carro para o seu nome.',
  DROP_OUT_INSUFfICIENT_VALUE:
    'Cliente desistiu da proposta: valor liberado é insuficiente.',
  DROP_OUT_UNINTEREST_GOT_RESOURCE_IN_ANOTHER_WAY:
    'Cliente desistiu do empréstimo.',
  DROP_OUT_HIGH_VALUE: 'Cliente desistiu por valor alto do empréstimo.',
  DROP_OUT_UNINTEREST_ONLY_EXPLORING: 'Cliente estava apenas simulando.',
  DROP_OUT_UNINTEREST_DONT_WANT_TO_ALIENATE_VEHICLE:
    'Cliente não quer alienar o carro.',
  DROP_OUT_UNINTEREST_LOAN: 'Cliente sem interesse no empréstimo.',
  DROP_OUT_UNINTEREST: 'Cliente sem interesse no momento.',
  DROP_OUT_UNINTEREST_INSTALLMENTS:
    'Cliente sem interesse no número de parcelas.',
  CONTACT_ATTEMPT_NOT_SUCCESS: 'Contato sem sucesso',
  EXCLUSION_BY_CLIENT: 'Exclusão de dados solicitada pelo cliente',
  CLOSED_WITH_COMPETITOR: 'Fechou com a concorrência.',
  OUT_OF_POLICY_VEHICLE_IN_BEHALF_OF_PJ:
    'Garantia fora da política interna: carro em nome de pessoa jurídica.',
  OUT_OF_POLICY_VEHICLE_REGISTERED_TO_THIRD_PART:
    'Garantia fora da política interna: carro em nome de terceiros.',
  OUT_OF_POLICY_VEHICLE_DEBT:
    'Garantia fora da política interna: carros possui débitos em aberto acima do aceito.',
  OUT_OF_POLICY_VEHICLE_MODEL:
    'Garantia fora da política interna: modelo de carro não aceito.',
  OUT_OF_POLICY_CONTACT_CONSULTANT:
    'Garantia fora da política interna: motivo não pode ser aberto. Fale com seu ponto de contato na Creditas para mais informações.',
  DROP_OUT: 'Motivo da desistência não informado.',
  EXPIRED_PROPOSAL: 'Proposta expirada por falta de atendimento.',
  OUT_OF_POLICY_DOESNT_HAVE_A_CAR:
    'Proposta fora da política interna: cliente não possui carro.',
  OUT_OF_POLICY_DATA_NOT_PROVEN:
    'Proposta fora da política interna: não foi possível confirmar os dados do cliente.',
  OUT_OF_POLICY_DOCUMENTS:
    'Proposta fora da política interna: problemas com a documentação do cliente.',
  OUT_OF_POLICY_LOW_INCOME:
    'Proposta fora da politica interna: renda abaixo do valor aceito.',
  OUT_OF_POLICY_INCOME_LOW_CREDIT:
    'Proposta fora da politica interna: renda abaixo do valor aceito.',
  OUT_OF_POLICY_INCOME_NOT_PROVEN:
    'Proposta fora da politica interna: renda não comprovada.',
  OUT_OF_POLICY:
    'Proposta fora da política interna: motivo não pode ser aberto.',
  OUT_OF_POLICY_VEHICLE_AUCTION:
    'Garantia fora da política interna: carro de leilão com nível de sucateamento acima do aceito.',
  CODE_ALLOWED: 'Garantia fora da política interna: modelo não aceito.',
  NEWLY_EMPLOYED:
    'Proposta fora da política interna: cliente possui menos de 6 meses de atuação no ramo.',
  BACEN_INCOME_COMMITMENT:
    'Proposta fora da política interna: elevado comprometimento de renda com os valores das parcelas existentes.',
  SCORE: 'Proposta fora da política interna: score abaixo do valor aceito.',
  VEHICLE_IQ:
    'Proposta fora da política interna: valor pré-aprovado insuficiente para quitar a dívida do carro em garantia',
  OUT_OF_POLICY_CLIENT_LIMIT_AGE:
    'Proposta fora da política interna: idade máxima, incluindo prazo de empréstimo, deve ser 75 anos.',
  OUT_OF_POLICY_CAR_LIEN:
    'Garantia fora da política interna: valor liberado é menor que o valor restante do financiamento do carro em garantia.',
  CONTACT_WHATSAPP: true,
  CONTACT_EMAIL: true,
  CONTACT_CHAT: true,
  CONTACT_PHONE: true,
}

export { FEED_ITEM_REJECTION_DESCRIPTION }
